import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "text-lg mb-2 mt-2 text-white"
};
const _hoisted_2 = {
  key: 1,
  class: "bg-slate-300 h-[3rem] mb-2 flex items-center pl-4 space-x-2 pr-4"
};
const _hoisted_3 = {
  class: "text-lg text-black"
};
const _hoisted_4 = {
  class: "text-pink-700"
};
const _hoisted_5 = {
  key: 2,
  class: "flex space-x-2 items-center mt-2 mb-6"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 i-mdi-clipboard"
}, null, -1);
const _hoisted_7 = {
  key: 3,
  class: "mb-4 grid grid-cols-3 gap-4 text-white"
};
const _hoisted_8 = {
  class: "flex items-center bg-black bg-opacity-40 h-full px-2"
};
const _hoisted_9 = {
  class: "my-1 mx-2"
};
import { ref } from 'vue';
import { copyTextToClipBoard } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'LinkShow',
  props: {
    show: {
      type: Boolean
    },
    invite_code: {}
  },
  setup(__props) {
    const props = __props;
    const extend_share_box = ref(false);
    const sharing = {
      url: 'https://minthe.io?c=',
      title: 'I am now using Minthe to create my own solana token',
      description: 'I think this is worth a try.',
      quote: '',
      hashtags: 'minthe,solana'
    };
    const sharing_network = [{
      network: 'facebook',
      name: 'Facebook',
      icon: ' i-cib-facebook',
      color: '#1877f2'
    }, {
      network: 'line',
      name: 'Line',
      icon: ' i-cib-line',
      color: '#00c300'
    }, {
      network: 'reddit',
      name: 'Reddit',
      icon: ' i-cib-reddit',
      color: '#ff4500'
    }, {
      network: 'telegram',
      name: 'Telegram',
      icon: 'i-cib-telegram-plane',
      color: '#0088cc'
    }, {
      network: 'twitter',
      name: 'Twitter',
      icon: 'i-cib-twitter',
      color: '#1da1f2'
    }, {
      network: 'whatsapp',
      name: 'Whatsapp',
      icon: 'i-cib-whatsapp',
      color: '#25d366'
    }];
    return (_ctx, _cache) => {
      const _component_ShareNetwork = _resolveComponent("ShareNetwork");
      return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.show && _ctx.invite_code != '' ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Your unique invite link created is:")) : _createCommentVNode("", true), _ctx.show && _ctx.invite_code != '' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_createTextVNode("https://minthe.io?c="), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.invite_code), 1)])])) : _createCommentVNode("", true), _ctx.show && _ctx.invite_code != '' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = $event => extend_share_box.value = !extend_share_box.value),
        class: _normalizeClass([extend_share_box.value ? 'bg-pink-600 text-white' : 'bg-gray-300', "hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-1 rounded items-center transition-colors h-full text-lg flex px-2"])
      }, [_createElementVNode("span", {
        class: _normalizeClass(["mr-1", 'i-mdi-arrow-down-drop-circle'])
      }), _createTextVNode(" Share ")], 2), _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = $event => _unref(copyTextToClipBoard)(`https://minthe.io?c=${_ctx.invite_code}`)),
        class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-1 rounded items-center transition-colors h-full text-lg flex px-2"
      }, [_hoisted_6, _createTextVNode(" Copy to Clipborad ")])])) : _createCommentVNode("", true), extend_share_box.value && _ctx.invite_code != '' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(sharing_network, network => {
        return _createVNode(_component_ShareNetwork, {
          style: _normalizeStyle(`background-color: ${network.color}80;`),
          class: "text-lg flex items-center hover:ml-1 transition-all",
          network: network.network,
          url: `${sharing.url}${_ctx.invite_code}`,
          title: sharing.title,
          description: sharing.description,
          quote: sharing.quote,
          hashtags: sharing.hashtags
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("i", {
            class: _normalizeClass(network.icon)
          }, null, 2)]), _createElementVNode("span", _hoisted_9, _toDisplayString(network.name), 1)]),
          _: 2
        }, 1032, ["style", "network", "url", "title", "description", "quote", "hashtags"]);
      }), 64))])) : _createCommentVNode("", true)], 64);
    };
  }
});